import React from 'react';
import FleetHealth from '../components/analytics/FleetHealth';

// Fleet health (MDM analytics) - its own page since 2026-10-30; the dashboard keeps a one-line strip.
export default function HealthPage() {
  return (
    <div className="page-shell">
      <FleetHealth />
    </div>
  );
}
